import * as React from 'react'

function SvgLightStraitsXLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="160"
      height="50"
      viewBox="0 0 160 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M135.793 19.4333C139.652 17.2123 140.02 14.0042 140.521 11.1564C140.822 9.42901 140.948 8.76025 140.948 8.76025H147.788C147.788 8.76025 147.463 10.5938 147.161 12.3187C146.668 15.1764 146.742 17.2542 143.003 19.4333L137.646 22.5204C133.786 24.7414 133.419 27.9494 132.92 30.7972C132.619 32.5246 132.493 33.1909 132.493 33.1909H125.65C125.65 33.1909 125.976 31.3574 126.277 29.6324C126.77 26.7748 126.696 24.697 130.435 22.5204L135.793 19.4333Z"
        fill="#00D37E"
      />
      <path
        d="M84.8213 13.5532H90.8426V33.2014H84.8213V13.5532ZM84.2586 8.27223C84.2586 6.44116 85.7023 5 87.8492 5C89.9961 5 91.4003 6.44116 91.4003 8.27223C91.4003 10.0663 89.9567 11.5099 87.8443 11.5099C85.7319 11.5099 84.2586 10.0663 84.2586 8.27223Z"
        fill="#051513"
      />
      <path
        d="M42.3119 28.0955H40.2414C38.9039 28.0955 38.4104 27.602 38.4104 26.4396V18.5429H41.4309L42.3119 13.5432H38.4104V8.76318H32.3891V26.3705C32.3891 31.4763 35.2418 33.2013 39.3259 33.2013H41.4111L42.3119 28.0955Z"
        fill="#051513"
      />
      <path
        d="M105.131 28.0955H103.06C101.723 28.0955 101.229 27.602 101.229 26.4396V18.5429H104.25L105.131 13.5432H101.229V8.76318H95.208V26.3705C95.208 31.4763 98.0607 33.2013 102.145 33.2013H104.233L105.131 28.0955Z"
        fill="#051513"
      />
      <path
        d="M59.1617 13.553H58.0857C56.869 13.526 55.6659 13.8131 54.5926 14.3868C53.5192 14.9604 52.6119 15.8011 51.9583 16.8277V13.553H45.937V33.2012H51.9583V24.0706C51.9583 20.6922 53.6142 19.7051 56.4669 19.7051H58.0857L59.1617 13.553Z"
        fill="#051513"
      />
      <path
        d="M68.3762 13.272C71.3005 13.272 73.3759 14.6095 74.4346 16.3344V13.5533H80.4559V33.2015H74.4346V30.4179C73.3414 32.1453 71.2635 33.5124 68.3417 33.5124C63.5518 33.5124 59.7046 29.5369 59.7046 23.3404C59.7046 17.1439 63.5518 13.272 68.3762 13.272ZM70.1382 18.5184C67.8852 18.5184 65.8419 20.2088 65.8419 23.3428C65.8419 26.4769 67.8852 28.2364 70.1382 28.2364C72.3913 28.2364 74.4346 26.509 74.4346 23.3774C74.4346 20.2458 72.4258 18.5184 70.1382 18.5184Z"
        fill="#051513"
      />
      <path
        d="M14.3375 27.3085C17.9133 28.9397 23.599 29.6578 23.715 27.4344C23.8704 24.2658 13 26.5534 13 19.3278C13 15.9791 15.8552 13.23 21.0029 13.23C23.6694 13.226 26.3144 13.7077 28.8084 14.6514L27.9792 19.3698C24.8526 18.0791 22.2269 17.7065 20.8228 17.7065C19.4186 17.7065 18.6363 18.2691 18.6363 19.2217C18.6363 22.0028 29.2822 20.1372 29.3883 27.4714C29.3883 30.8892 26.3579 33.4631 21.4224 33.4631C18.7177 33.5546 16.0249 33.0649 13.5256 32.0268L14.3375 27.3085Z"
        fill="#051513"
      />
      <path
        d="M108.83 27.3085C112.403 28.9397 118.089 29.6578 118.207 27.4343C118.363 24.2658 107.492 26.5534 107.492 19.3278C107.492 15.9791 110.348 13.23 115.493 13.23C118.16 13.2263 120.806 13.7079 123.301 14.6514L122.467 19.3698C119.355 18.0767 116.727 17.7065 115.31 17.7065C113.894 17.7065 113.116 18.2691 113.116 19.2217C113.116 22.0028 123.762 20.1372 123.868 27.4714C123.868 30.8892 120.836 33.463 115.903 33.463C113.194 33.5564 110.496 33.0666 107.993 32.0268L108.83 27.3085Z"
        fill="#051513"
      />
      <path
        d="M134.223 18.5725H131.422C130.292 18.5705 129.198 18.1709 128.333 17.4436C127.467 16.7163 126.885 15.7077 126.689 14.5945L125.66 8.76318H132.503L134.223 18.5725Z"
        fill="#00D37E"
      />
      <path
        d="M139.218 23.3921H142.016C143.149 23.3917 144.246 23.7905 145.114 24.5185C145.981 25.2465 146.565 26.257 146.762 27.3726L147.788 33.2014H140.948L139.218 23.3921Z"
        fill="#00D37E"
      />
    </svg>
  )
}

export default SvgLightStraitsXLogo
